export default {
  apiKey: 'AIzaSyCZTfR3EdNeYJXPxasbafDG302Eno-ECyk',
  authDomain: 'numisma-acfba.firebaseapp.com',
  databaseURL: 'https://numisma-acfba.firebaseio.com',
  projectId: 'numisma-acfba',
  storageBucket: 'numisma-acfba.appspot.com',
  messagingSenderId: '726760483742'
}



//////////////////
// WEBPACK FOOTER
// ./config/firebase.env.js
// module id = 416
// module chunks = 5